import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useSelector} from "../../../shared-services/redux-tiny";
import {FarmyColumnSet, FarmyColumn} from "../../layouts/components/FarmyColumns";
import useCartButtons from "../useCartButtons";
import useWindowTools from "../../../react-hooks/useWindowTools";
import FarmyAnchoredDialog from "../../topLayer/popovers/FarmyAnchoredDialog";
import currentTheme from "../../../react-themes/theme";
import {t} from "../../../shared-services/translate";

const theme = currentTheme();

const CartButtonsPDP = (props) => {
  const {className = "", style} = props;

  const {currentZipcode} = useSelector(state => state.session);
  const [showGoToCartDialog, setGoToCart] = useState(false);
  const [dialogTimeout, setDialogTimeout] = useState(null);
  const cartDialogTimeout = 2000;

  const {isMobile} = useWindowTools();

  const hideGoToCartDialog = () => {
    requestAnimationFrame(() => setGoToCart(false));
  };

  const onAddToCart = () => {
    if (!currentZipcode) return;
    if (dialogTimeout) clearTimeout(dialogTimeout);
    setGoToCart(true);

    setDialogTimeout(
      setTimeout(hideGoToCartDialog, cartDialogTimeout)
    );
  };

  const getTrackingListName = () => {
    const {productFromSearch} = window;
    return productFromSearch?.trackingListName || "PDP";
  };

  const cartOptions = {
    callerLocation: "productpage",
    trackingListName: getTrackingListName(),
    onAddToCart,
    onIncrease: onAddToCart
  };

  const {
    AddToCartButton,
    IncreaseButton,
    DecreaseButton,
    lineItem,
    parsedQuantity,
    isLastVariant
  } = useCartButtons(props.product, cartOptions);

  useEffect(() => {
    return () => {
      if (dialogTimeout) clearTimeout(dialogTimeout);
    };
  }, []);

  return <div className={`full-width ${className} position-relative`} style={style}>
    <GoToCartDialog show={showGoToCartDialog}/>

    {lineItem
      ? (
        <div className="panel-out border-radius-xl border-default border-color-light">
          <div
            className="panel-in border-radius-xl background-color-lightest-grey"
            style={{
              border: "4px solid white"
            }}
          >
            <FarmyColumnSet gap="10px" className="align-items-center">
              <FarmyColumn width="50%">
                <DecreaseButton
                  product={props.product}
                  size="lg"
                  color="transparent"
                  className="full-width active-shadow text-color-green"
                  style={{
                    borderBottomRightRadius: "0",
                    borderTopRightRadius: "0",
                    transition: "box-shadow 100ms"
                  }}
                />
              </FarmyColumn>
              <FarmyColumn width="50%">
                <div className="full-width flex flex-direction-column align-items-center">
                  <div className="font-weight-900 font-size-body-bigger text-align-center">
                    {parsedQuantity?.quantity}
                  </div>
                  <div className="text-align-center text-color-dimmed text-small font-weight-600">
                    {parsedQuantity?.unit}
                  </div>
                </div>
              </FarmyColumn>
              <FarmyColumn width="50%">
                <IncreaseButton
                  product={props.product}
                  size="lg"
                  color="transparent"
                  className={`
                  full-width
                  ${isLastVariant ? "text-color-dimmed" : "text-color-green active-shadow"}
                  `}
                  style={{
                    borderBottomLeftRadius: "0",
                    borderTopLeftRadius: "0",
                    transition: "box-shadow 100ms"
                  }}
                />
              </FarmyColumn>
            </FarmyColumnSet>
          </div>
        </div>
      )

      : (
        <AddToCartButton
          product={props.product}
          size={isMobile || !props.product?.available_to_add_to_cart ? "lg" : "xl"}
          color="orange"
          className={"full-width"}
          classNameDisabled="line-height-short"
          style={{lineHeight: isMobile ? "1em" : null, minHeight: isMobile ? "59px" : null}}
        />
      )}
  </div>;
};

export default CartButtonsPDP;

const GoToCartDialog = (props) => {
  const {show} = props;

  return <Link to={"/cart"}>
    <DialogBelowCart
      show={show}
      borderColor={theme.colors.farmy.green}
      className={`
          flex
          align-items-center
          justify-content-center
          gap-10
        `}
    >
      <img
        alt="go to cart"
        src="/resources/farmy/images/icons/cart.svg"
        loading="lazy"
      />
      <span className="font-weight-600 text-color-green">
        {t("go_to_cart")}
      </span>
    </DialogBelowCart>
  </Link>;
};

const DialogBelowCart = (props) => {
  const {
    borderColor,
    children,
    className = "",
    style,
    ...additionalProps
  } = props;

  const {isMobile} = useWindowTools();

  return <FarmyAnchoredDialog
    closeOnClickOutside={false}
    animationDirection={isMobile ? "up" : "down"}
    className={`
            full-width
            soft-shadow
            background-color-white
            border-radius-lg
            border-default
            padding-15
            ${className}
          `}
    style={{
      right: "0",
      top: isMobile ? null : "calc(100% + 5px)",
      bottom: isMobile ? "calc(100% + 5px)" : null,
      borderColor,
      ...style
    }}
    {...additionalProps}
  >
    <div
      className={`
        little-pointer
        position-absolute
        top-0
        full-width
        flex align-items-center
        justify-content-center
      `}
      style={{
        top: isMobile ? "calc(100% - 4px)" : "-6px"
      }}
    >
      <div
        className="border-default background-color-white"
        style={{
          transform: "rotate(45deg)",
          width: "10px",
          height: "10px",
          borderRight: isMobile ? null : "none",
          borderBottom: isMobile ? null : "none",
          borderLeft: isMobile ? "none" : null,
          borderTop: isMobile ? "none" : null,
          borderColor
        }}
      >
      </div>
    </div>
    {children}
  </FarmyAnchoredDialog>;
};
